import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'COMISSAO_OPERACAO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'COMISSAO_OPERACAO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('comissaoOperacaoForm', registro)
    ];
}

export function setFiltro(filtro) {
    return {
        type: 'COMISSAO_OPERACAO_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function getLista() {
	return (dispatch, getState) => {
		dispatch(setAguardando(true));

		const filtro = getState().comissaoOperacao.filtro;

    	axios.get(`${consts.API_URL}/comissaoOperacao?padrao=true
			&data=${DateFormat.formatarDataTelaParaSql(filtro.data) == 'Invalid DateTime' ? DateFormat.getDataAtual() : DateFormat.formatarDataTelaParaSql(filtro.data)}
			&id_operacao=${filtro.id_operacao || null}
			&id_termo=${filtro.id_termo || null}
			&id_vinculo=${filtro.id_vinculo || null}
			&id_colaborador=${filtro.id_colaborador || null}
			&id_tipo=${filtro.id_tipo || null}
			&id_status=${filtro.id_status || null}
		`).then(resp => {
			dispatch({
		        type: 'COMISSAO_OPERACAO_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/comissaoOperacao`, {
				...registro,
				data_base: DateFormat.formatarDataTelaParaSql(registro.data_base),
				data_inicio: DateFormat.formatarDataTelaParaSql(registro.data_inicio),
				data_fim: DateFormat.formatarDataTelaParaSql(registro.data_fim),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/comissaoOperacao`, {
				...registro,
				data_base: DateFormat.formatarDataTelaParaSql(registro.data_base),
				data_inicio: DateFormat.formatarDataTelaParaSql(registro.data_inicio),
				data_fim: DateFormat.formatarDataTelaParaSql(registro.data_fim),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/comissaoOperacao?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaOperacao() {
    const request = axios.get(`${consts.API_URL}/operacao/listarSelect`);
    return {
        type: 'COMISSAO_OPERACAO_OPERACAO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaComissaoTermo() {
    const request = axios.get(`${consts.API_URL}/comissaoTermo/listarSelect`);
    return {
        type: 'COMISSAO_OPERACAO_TERMO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaComissaoVinculo() {
    const request = axios.get(`${consts.API_URL}/comissaoVinculo/listarSelect`);
    return {
        type: 'COMISSAO_OPERACAO_VINCULO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaUsuario() {
    const request = axios.get(`${consts.API_URL}/usuario/listarSelect`);
    return {
        type: 'COMISSAO_OPERACAO_USUARIO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaComissaoTipo() {
    const request = axios.get(`${consts.API_URL}/comissaoTipo/listarSelect`);
    return {
        type: 'COMISSAO_OPERACAO_COMISSAO_SELECT_LISTADO',
        payload: request
    };
}